/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum EnvEnum {
  dev = 'Development',
  prod = 'Production',
}

export const env: EnvEnum =
  process.env.NODE_ENV == 'development' ? EnvEnum.dev : EnvEnum.prod;

const AppSettings = {
  auth: {
    access: {
      name: 'accessToken',
      durationDays: 24 / 1,
    },
    refresh: {
      name: 'refreshToken',
      durationDays: 30,
    },
  },
  api: {
    // url: 'http://localhost:3010',
    url: 'https://tcb.chmerev.com',
  },
  income_stages: ['d6ZMGwE320-l2MaPw4kUzg'],
  in_work_stages: [
    'ndwysnoeM0KRPTzgJpd4Ng',
    'YK7zsn5KEUm55Gqhf8YlEA',
    'Si2OxME99k6rRW9QXEYbcg',
    'zlpMFPgBiEODvi99wyhOSw',
    'PaY4d-32y0-IIdWH3BZERQ',
    'uwjcLgAb-0mrsS1FGUDISQ',
  ],
  realized_stages: ['ofE8eo04HkucTlHTSoXiIw'],
  unrealized_stages: ['aoPypKs9g0KiabFGwkWKnQ'],
  bronIds: [
    'INgDeb2sQUmnfAKBkDoYsQ', // Детская нутрициология | Бронь курса
    'TrMdyOXYcU63qThXDWdE5Q', // ANTI AGE | Бронь курса
    'O5FJPrch9EWAULwNqFhnFQ', // Я Нутрициолог | Бронь курса
    '11beKPyH_kmBmVkFnMvQeg', // Я Нутрициолог | Бронь курса (Живой ивент)
    'rmYMGiRnpUySSEBmSkwVaQ', // Детская нутрициология | Бронь курса (Живой ивент)
    'DGa5jiIrzki8Sb2R3mUZjQ', // Я Нутрициолог | Бронь курса (для ДНК)
    'HxCShldKGk-WauH6b0hYYg', // Я Нутрициолог + ANTI AGE | Бронь курса
    'TrR7xeM0mk6byVejA2sjdg', // Интегративная Нутрициология | Бронь курса
    'qom0J6A9E0-OXHsgZ8xzKw', // Интегративная Нутрициология | Бронь курса (Живой ивент)
    'pWgw-w7lwUCIcjAQng6QaA', // Бронь курса Интегративный нутрициолог
  ],
  bronIdsSsd: [
    '_Dgmoq2MKEGo8ifQox6j9w', // ССД | Бронь курса
    'gpPnqdyKFkmYjnVRMlT3jw', // ДНК стройности и здоровья | Бронь курса (Живой ивент)
  ],
};

export { AppSettings };
